/**
 * The Documents destinations column's width (desktop), remembered in this
 * browser. Spec: `.claude/features/documents-flush-resizable-nav.md`.
 * Exported for the cold-load skeleton, which renders before the page and
 * draws the column at the width the page will use. The Notetaker page draws
 * the same column and keeps its width under a key of its own.
 */
export const DOCUMENTS_NAV_DEFAULT_PX = 272;
export const DOCUMENTS_NAV_MIN_PX = 200;
export const DOCUMENTS_NAV_MAX_PX = 440;

/** Where this browser keeps the width; stories read it back. */
export const DOCUMENTS_NAV_WIDTH_KEY = "documents-nav-width";
/** The Settings rail takes the same column (#13370, round 11), sized on its own. */
export const SETTINGS_NAV_WIDTH_KEY = "settings-nav-width";
const WIDTH_KEY = DOCUMENTS_NAV_WIDTH_KEY;

export function clampDocumentsNavWidth(width: number): number {
  return Math.min(
    DOCUMENTS_NAV_MAX_PX,
    Math.max(DOCUMENTS_NAV_MIN_PX, Math.round(width))
  );
}

/** `key` lets another page that draws this column (the Notetaker) keep a
 *  width of its own. */
export function readStoredDocumentsNavWidth(key: string = WIDTH_KEY): number {
  try {
    const stored = Number(localStorage.getItem(key));
    if (Number.isFinite(stored) && stored > 0) {
      return clampDocumentsNavWidth(stored);
    }
  } catch (error) {
    console.error("Failed to read the Documents column width:", error);
  }
  return DOCUMENTS_NAV_DEFAULT_PX;
}

export function writeStoredDocumentsNavWidth(
  width: number,
  key: string = WIDTH_KEY
): void {
  try {
    localStorage.setItem(key, String(clampDocumentsNavWidth(width)));
  } catch (error) {
    console.error("Failed to save the Documents column width:", error);
  }
}
